<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-clipboard-check"></i> ใบรับสินค้า</h4>

          <div class="d-flex flex-column flex-sm-row mx-1 my-3 gap-2">
            <b-form-input
              type="search"
              class="flex-grow-1"
              autofocus
              v-model="filter"
              placeholder="ค้นหาใบรับสินค้า จากรหัสใบรับสินค้า รหัสใบสั่งซื้ออ้างอิง หรือชื่อผู้ขาย"
            ></b-form-input>
            <b-button
              class="flex-shrink-0 mt-2 mt-sm-0 ml-sm-3"
              variant="primary"
              @click="openCreateModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="goodsReceiveTable"
            ref="goodsReceiveTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getGoodsReceiveList"
            :fields="fields"
            :filter="filter"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(createdAt)="row">
              {{ formatDate(row.value) }}
            </template>
            <template v-slot:cell(buttons)="row">
              <div class="action-icons">
                <i
                  class="fas fa-info-circle action-icon info-icon"
                  title="ดูรายละเอียด"
                  @click="openDetailModal(row.item)"
                ></i>
                <i
                  class="fas fa-edit action-icon edit-icon"
                  :class="{ 'icon-disabled': !isEditable(row.item) }"
                  :title="
                    isEditable(row.item)
                      ? 'แก้ไข'
                      : 'ไม่สามารถแก้ไขได้'
                  "
                  @click="
                    isEditable(row.item) && openEditModal(row.item)
                  "
                ></i>
                <i
                  class="fas fa-trash-alt action-icon delete-icon"
                  :class="{ 'icon-disabled': !isEditable(row.item) }"
                  :title="
                    isEditable(row.item)
                      ? 'ลบ'
                      : 'ไม่สามารถลบได้'
                  "
                  @click="
                    isEditable(row.item) &&
                      deleteGoodsReceive(row.item)
                  "
                ></i>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <GoodsReceiveItem ref="goodsReceiveItemModal"></GoodsReceiveItem>
      <GoodsReceiveDetail ref="goodsReceiveDetailModal"></GoodsReceiveDetail>

      <!-- Delete confirmation modal -->
      <b-modal
        id="deleteConfirmModal"
        ref="deleteConfirmModal"
        no-close-on-backdrop
        centered
        @hidden="deleteTarget = null"
        hide-header-close
      >
        <template v-slot:modal-header="{ close }">
          <h5 class="modal-title">
            <i class="fas fa-exclamation-circle text-danger mr-2"></i>
            ลบใบรับสินค้า
          </h5>
          <button type="button" class="close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <p class="mb-0">คุณต้องการลบใบรับสินค้านี้ใช่หรือไม่</p>
        <template v-slot:modal-footer>
          <b-button
            variant="outline-secondary"
            @click="$bvModal.hide('deleteConfirmModal')"
          >
            ย้อนกลับ
          </b-button>
          <b-button variant="danger" @click="confirmDelete">
            ลบรายการ
          </b-button>
        </template>
      </b-modal>

      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import GoodsReceiveItem from "../../components/modal/ProductAndStock/GoodsReceiveItem.vue";
import GoodsReceiveDetail from "../../components/modal/ProductAndStock/GoodsReceiveDetail.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import { THAI_MONTHS } from "@/constants";
import Loading from "@/components/Loading";

export default {
  name: "GoodsReceive",
  components: {
    GoodsReceiveItem,
    GoodsReceiveDetail,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      deleteTarget: null,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "4%" },
          tdClass: "index-cell",
        },
        {
          key: "grCode",
          label: "รหัสใบรับสินค้า",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
        },
        {
          key: "poRefCode",
          label: "รหัสใบสั่งซื้ออ้างอิง",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
        },
        {
          key: "vendorName",
          label: "ชื่อผู้ขาย",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
          tdClass: "vendor-name-cell",
        },
        {
          key: "createdAt",
          label: "วันที่สร้าง",
          sortable: true,
          sortDirection: "desc",
          thStyle: { width: "18%", whiteSpace: "nowrap" },
        },
        {
          key: "buttons",
          label: "",
          thStyle: { width: "12%" },
          class: "text-center",
        },
      ],
      filter: null,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getGoodsReceiveList: "moduleGoodsReceive/getGoodsReceiveList",
      getProductList: "moduleProductInventory/getProductList",
    }),
  },
  methods: {
    ...mapActions({
      fetchGoodsReceiveList: "moduleGoodsReceive/fetchGoodsReceiveList",
      fetchProductList: "moduleProductInventory/fetchProductList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchGoodsReceiveList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
        // Try fetching real product list; ignore error if API not ready
        await this.fetchProductList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        }).catch(() => {});
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการใบรับสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    openCreateModal() {
      this.$refs.goodsReceiveItemModal.show({
        productList: this.getProductList,
      });
    },
    openEditModal(goodsReceive) {
      this.$refs.goodsReceiveItemModal.show({
        goodsReceive,
        productList: this.getProductList,
      });
    },
    openDetailModal(goodsReceive) {
      this.$refs.goodsReceiveDetailModal.show(goodsReceive);
    },
    deleteGoodsReceive(item) {
      this.deleteTarget = item;
      this.$bvModal.show("deleteConfirmModal");
    },
    confirmDelete() {
      if (!this.deleteTarget) return;
      this.$bvModal.hide("deleteConfirmModal");

      this.isLoading = true;
      this.$store
        .dispatch("moduleGoodsReceive/deleteGoodsReceive", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: this.deleteTarget.id,
        })
        .then(res => {
          if (res.status === 200) {
            this.deleteTarget = null;
            this.init();
            this.showDialogToast("success", "ลบรายการใบรับสินค้าสำเร็จ");
          }
        })
        .catch(err => {
          const errorMessage = err.response?.data?.errorMessage;
          const errorMsg =
            typeof errorMessage === "string"
              ? errorMessage
              : "ลบใบรับสินค้าไม่สำเร็จ กรุณาลองใหม่";
          this.showDialogToast("danger", errorMsg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = THAI_MONTHS[date.getMonth()];
      const buddhistYear = String(date.getFullYear() + 543).slice(-2);
      return `${day} ${month} ${buddhistYear}`;
    },
    isEditable(item) {
      if (!item || !item.createdAt) return false;
      const cutoff = new Date(item.createdAt);
      if (isNaN(cutoff.getTime())) return false;
      cutoff.setHours(23, 0, 0, 0);
      return new Date() <= cutoff;
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped>
::v-deep #goodsReceiveTable {
  table-layout: auto;
}

::v-deep #goodsReceiveTable thead th {
  padding: 16px 24px;
}

::v-deep #goodsReceiveTable tbody td {
  padding: 16px 24px;
  vertical-align: middle;
}

::v-deep .index-cell {
  white-space: nowrap;
}

::v-deep .vendor-name-cell {
  word-break: break-word;
  white-space: normal;
}

.action-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.action-icon {
  font-size: 1.25rem;
  color: #adb5bd;
  cursor: pointer;
  transition: color 0.2s ease;
}

.action-icon:hover:not(.icon-disabled) {
  color: #495057;
}

.info-icon {
  font-size: 1.35rem;
}

.icon-disabled {
  color: #dee2e6;
  cursor: not-allowed;
  pointer-events: none;
}

.gap-2 {
  gap: 0.5rem;
}

@media (max-width: 576px) {
  ::v-deep #goodsReceiveTable thead th,
  ::v-deep #goodsReceiveTable tbody td {
    padding: 10px 12px;
  }

  .action-icons {
    gap: 10px;
  }

  .action-icon {
    font-size: 1.1rem;
  }
}

</style>
